import styled from 'styled-components';
import { Link } from 'react-scroll';

export const ProjectsContainer = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
    overflow: hidden;

    @media screen and (max-width: 768px) {
        height: 1100px;
    }

    @media screen and (max-width: 480px) {
        height: 1300px;
    }
`;

export const ProjectsH1 = styled.h1`
    font-size: 32px;
    margin-bottom: 16px;
    color: #fff;
    padding-top: 20px;
    height: 5%;
    text-align: center;
`;

export const ProjectsTimeLine = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 5%;
    margin-top: 15px;
`;

export const ProjectsYear = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #40617e;
    font-size: 1.5rem;
`;

export const ProjectsYearSpan = styled(Link)`
    color: #fff;
    font-size: 1.5rem;
    padding: 15px 10px;    
    text-align: center;

    &:hover {
        text-decoration: none;
        color: #fff;
    }
`;

export const ProjectsBody = styled.div`
    width: 100%;
    height: 100%;
`;

